import { Link } from '@packages/shared';
import type { FC } from 'react';
import type { BrandHeadline } from '../../api/rest/types';

export type BrandListHeadlineProps = {
  items: BrandHeadline[];
};

/**
 * Headline component for BrandList
 * */
export const BrandListHeadline: FC<BrandListHeadlineProps> = ({ items }) => (
  <div>
    {items.map((item) => (
      <Link
        sx={{
          display: 'inline-block',
          margin: (theme) => theme.spacing(0.55),
          fontSize: (theme) => theme.typography.h5.fontSize,
          '&:not(:hover)': {
            color: (theme) => theme.palette.text.primary,
            textDecorationColor: (theme) => theme.palette.text.primary,
          },
        }}
        href={`${item.uri.toLowerCase()}`}
        key={`${item.uri.toLowerCase()}`}
        underline="always"
      >
        {item.title}
      </Link>
    ))}
  </div>
);
